import type { GeneratedLesson } from "../types";
import { Download, Copy, RefreshCw, Save } from "lucide-react";

interface ActionButtonsProps {
  lesson: GeneratedLesson;
  onSave?: () => void;
  onCopy?: () => void;
  onDownload?: () => void;
  onRegenerate?: () => void;
}

export function ActionButtons({
  lesson,
  onSave,
  onCopy,
  onDownload,
  onRegenerate,
}: ActionButtonsProps) {
  const buttons = [
    {
      icon: Save,
      label: "Salvar",
      onClick: onSave,
      primary: true,
    },
    {
      icon: Copy,
      label: "Copiar",
      onClick: onCopy,
      primary: false,
    },
    {
      icon: Download,
      label: "Baixar PDF",
      onClick: onDownload,
      primary: false,
    },
    {
      icon: RefreshCw,
      label: "Gerar Novamente",
      onClick: onRegenerate,
      primary: false,
    },
  ];

  return (
    <div
      className="flex flex-wrap gap-3 mt-8 pt-6 border-t"
      style={{ borderColor: "var(--border-color)" }}
    >
      {buttons.map((button) => {
        const Icon = button.icon;
        return (
          <button
            key={button.label}
            onClick={button.onClick}
            className={`flex items-center gap-2 px-4 py-2 rounded-lg transition ${
              button.primary
                ? "font-bold text-white hover:opacity-90"
                : "border hover:bg-(--bg-accent)"
            }`}
            style={{
              backgroundColor: button.primary
                ? "var(--primary-color)"
                : "transparent",
              borderColor: !button.primary
                ? "var(--border-color)"
                : "transparent",
              color: button.primary ? "white" : "var(--text-primary)",
            }}
          >
            <Icon className="w-4 h-4" />
            {button.label}
          </button>
        );
      })}
    </div>
  );
}
